import { AuthLayout } from "@/layouts/AuthLayout";
import {
  Anchor,
  Button,
  Divider,
  Flex,
  rem,
  rgba,
  Text,
  useMantineColorScheme,
} from "@mantine/core";
import { GoogleSignInButton } from "./components/GoogleSignInButton";
import { Link } from "react-router-dom";
import { LoginForm } from "./components/LoginForm";
import { useLoginController } from "./hooks/useLoginController";

export default function LoginPage() {
  const {
    form,
    loading,
    handleLogin,
    credentialsErrorActive,
    credentialsErrorMessage,
    handleCredentialsFieldInteraction,
  } = useLoginController();

  const { colorScheme } = useMantineColorScheme();
  const FORM_ID = "login-form";

  const LoginTitle = (
    <Text
      component="h4"
      fz={20}
      ff={"heading"}
      mb={"min(max(5%, 12px), 32px)"}>
      Digite seu e-mail e senha para acessar a sua conta
    </Text>
  );

  const LoginActionsAndFooter = (
    <Flex
      direction="column"
      gap="md">
      <Button
        fullWidth
        size="sm"
        type="submit"
        form={FORM_ID}
        radius={rem(8)}
        title="Informe suas credenciais para entrar"
        loading={loading}
        disabled={!form.isValid() || loading}
        bg={"var(--mantine-color-contrast_text-0)"}
        ff={"heading"}
        fz={16}
        fw={700}>
        Entrar
      </Button>

      <Divider
        label="ou"
        labelPosition="center"
      />
      <GoogleSignInButton />

      <Text
        ta={"center"}
        fz={16}
        c={
          colorScheme === "light"
            ? rgba("var(--mantine-color-D900-0)", 0.5)
            : rgba("var(--mantine-color-L100-0)", 0.5)
        }>
        Novo no Super Agents?{" "}
        <Anchor
          component={Link}
          to={"/signup"}
          style={{
            color: "var(--mantine-color-R500-0)",
            fontWeight: 700,
            fontSize: 16,
          }}>
          Criar conta
        </Anchor>
      </Text>
    </Flex>
  );

  return (
    <AuthLayout
      title={LoginTitle}
      footer={LoginActionsAndFooter}>
      <LoginForm
        form={form}
        formId={FORM_ID}
        onSubmit={handleLogin}
        credentialsErrorActive={credentialsErrorActive}
        credentialsErrorMessage={credentialsErrorMessage}
        onCredentialsInteraction={handleCredentialsFieldInteraction}
      />
    </AuthLayout>
  );
}
